(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const track = root.querySelector('[data-vpp-track]');
    const slides = [...root.querySelectorAll('[data-vpp-slide]')];
    const thumbs = [...root.querySelectorAll('[data-vpp-thumb]')];
    const previous = root.querySelector('[data-vpp-prev]');
    const next = root.querySelector('[data-vpp-next]');
    const position = root.querySelector('[data-vpp-position]');
    let index = 0;
    const go = target => {
      index = Math.max(0, Math.min(slides.length - 1, target));
      track.scrollTo({left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    };
    function update() {
      if (!slides.length) return;
      index = slides.reduce((best, slide, i) => Math.abs(slide.offsetLeft - slides[0].offsetLeft - track.scrollLeft) < Math.abs(slides[best].offsetLeft - slides[0].offsetLeft - track.scrollLeft) ? i : best, 0);
      thumbs.forEach((thumb, i) => { if (i === index) thumb.setAttribute('aria-current', 'true'); else thumb.removeAttribute('aria-current'); });
      if (position) position.textContent = `${index + 1} / ${slides.length}`;
      if (previous) previous.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    }
    const controls = root.querySelector('[data-vpp-controls]');
    if (controls) controls.hidden = false;
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', event => {event.preventDefault(); go(i);}));
    previous?.addEventListener('click', () => go(index - 1));
    next?.addEventListener('click', () => go(index + 1));
    track?.addEventListener('keydown', event => {if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault();go(index + (event.key === 'ArrowRight' ? 1 : -1));}});
    track?.addEventListener('scroll', update, {passive: true});
    if (track) new ResizeObserver(update).observe(track);
    root.querySelector('[data-vpp-variant]')?.addEventListener('change', event => {
      const url = new URL(location.href);
      url.searchParams.set('variant', event.target.value);
      location.assign(url.href);
    });
    update();
  }
  document.querySelectorAll('[data-vpp]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-vpp]').forEach(init));
})();

(() => {
  function initCards(root) {
    if (root.dataset.cardsReady) return;
    root.dataset.cardsReady = 'true';
    const modal = root.querySelector('[data-vpp-dialog]');
    const image = modal?.querySelector('[data-vpp-dialog-image]');
    const title = modal?.querySelector('[data-vpp-dialog-title]');
    const meta = modal?.querySelector('[data-vpp-dialog-meta]');
    const close = modal?.querySelector('[data-vpp-dialog-close]');
    let lastTrigger;
    const motion = matchMedia('(pointer:fine) and (prefers-reduced-motion:no-preference)');
    function tilt(target, surface) {
      if (!surface) return;
      let frame;
      target.addEventListener('pointermove', event => {
        if (!motion.matches) return;
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const rect = target.getBoundingClientRect();
          const x = (event.clientX - rect.left) / rect.width;
          const y = (event.clientY - rect.top) / rect.height;
          surface.style.setProperty('--rotate-x', `${((.5 - y) * 20).toFixed(2)}deg`);
          surface.style.setProperty('--rotate-y', `${((x - .5) * 24).toFixed(2)}deg`);
        });
      }, {passive:true});
      target.addEventListener('pointerleave', () => {
        cancelAnimationFrame(frame);
        surface.style.setProperty('--rotate-x','0deg');
        surface.style.setProperty('--rotate-y','0deg');
      });
    }
    root.querySelectorAll('[data-vpp-card]').forEach(trigger => {
      tilt(trigger, trigger.querySelector('[data-vpp-tilt]'));
      trigger.addEventListener('click', () => {
        if (!modal || !image) return;
        lastTrigger = trigger;
        title.textContent = trigger.dataset.cardName;
        meta.textContent = `${trigger.dataset.cardNumber} · ${trigger.dataset.cardRarity}`;
        image.src = trigger.dataset.cardImage;
        image.alt = trigger.dataset.cardAlt;
        image.hidden = false;
        modal.showModal();
        close.focus();
      });
    });
    if (!modal) return;
    tilt(modal.querySelector('.vpp-dialog-photo'), modal.querySelector('.vpp-dialog-photo'));
    close.addEventListener('click', () => modal.close());
    modal.addEventListener('click', event => {if (event.target === modal) {const r=modal.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)modal.close();}});
    modal.addEventListener('close', () => lastTrigger?.focus());
  }
  document.querySelectorAll('[data-vpp]').forEach(initCards);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-vpp]').forEach(initCards));
})();

(() => {
  function initRelated(root) {
    if (root.dataset.relatedReady) return;
    root.dataset.relatedReady = 'true';
    const track = root.querySelector('[data-vpp-related-results]');
    const previous = root.querySelector('[data-vpp-related-prev]');
    const next = root.querySelector('[data-vpp-related-next]');
    if (!track) return;
    function state() {
      previous.disabled = track.scrollLeft < 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    function move(direction) {
      const card = track.querySelector('[data-vpp-related-card]');
      const distance = card ? card.getBoundingClientRect().width + 18 : track.clientWidth;
      track.scrollBy({left: direction * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', state, {passive:true});
    track.addEventListener('keydown', event => {if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}});
    new ResizeObserver(state).observe(track);
    state();
    const observer = new IntersectionObserver(async entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      observer.disconnect();
      try {
        const response = await fetch(root.dataset.url);
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const result = doc.querySelector('[data-vpp-related-results]');
        if (result?.querySelector('[data-vpp-related-card]')) {
          track.replaceChildren(...[...result.children].map(child=>document.importNode(child,true)));
          root.dataset.source = 'shopify';
          state();
        }
      } catch {}
    }, {rootMargin:'300px'});
    observer.observe(root);
  }
  function start(){document.querySelectorAll('[data-vpp-related]').forEach(initRelated);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
  document.addEventListener('shopify:section:load',start);
})();
